import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
 import FaCopy from 'react-icons/lib/fa/copy';
 import IODocumentText from 'react-icons/lib/io/document-text';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import {
    ADD_SELECTED_CONTRACTORS,REMOVE_SELECTED_CONTRACTORS  }  from "actions/actionTypes";
import config from  '../../../../config';
import { formatImageForBucket } from '../../../util/Utils';
import {Link} from 'react-router';
import {getFieldByPathFormatter,priceFormatter,imagesFormatter, linkFormatter, customTableSelect,customFormatter,dateFormatter, actionsFormatter} from 'util/Utils';
class AMTSalesProductsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            recordIDs:[],
            perPage: config.table.numberPerPage
        };
    }
    customActionsFormatter(cell, row, extra){
        var menuItemsMap  =    [  ]
        menuItemsMap.push({onClick: (row)=> {
            this.props.openModalDialog(row, 'SignUpForNotification' )
        }, label: 'Manage notifications'})
        menuItemsMap.push({onClick: (row)=> {
            this.props.openModalDialog(row, 'AddUserNotes' )
        }, label: 'Add note'})
        return  actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    onRowSelect(row, isSelected, e) {
         var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
         this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        var actionName =   isSelected ? ADD_SELECTED_CONTRACTORS : REMOVE_SELECTED_CONTRACTORS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
       return customTableSelect(props, {table:this.refs.table, selectedRows:this.props.adminContractors.selectedContractors});
    }



    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.props.onRowSelect,
            onSelectAll: this.props.onAllRowSelect,
            customComponent: this.props.customMultiSelect
          //  onSelect: this.onRowSelect.bind(this),
         //   onSelectAll: this.onAllRowSelect.bind(this),
         //   customComponent: this.customMultiSelect.bind(this)
        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.tableData}
                                 //   selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn width="150px" dataField='ProductName' dataAlign="center" dataFormat={ customFormatter }
                                           formatExtraData={ {path: 'getObject' ,
                                                format: (row)=> {
                                                return   <div>
                                                   {(_.get(row, 'Status') == 'Active' && _.get(row, 'ShopifyProductHandle')) ?
                                                       <span  className="left20 pull-left right10">
                                                           <span
                                                          >{ linkFormatter({}, row, {
                                                               labelPath: ['ProductName'],
                                                               path: ['ShopifyProductHandle'],
                                                           placeholder: '[product_handle]',
                                                           template: config.getEnvironment().shopify.productCustomerUrlTemplate,
                                                       })}</span>
                                                           {(_.get(row, 'Status') == 'Inactive' || _.get(row, 'ProductVariants.0.Quantity') < 1) &&
                                                           <span   className="pleft10  red ">Sold</span>
                                                           }</span>:
                                                       <span
                                                           className="left20 pull-left right10"><span>{ _.get(row, ['ProductName'], '')}</span>
                                                           {( _.get(row, 'ProductVariants.0.Quantity') < 1) &&
                                                           <span   className="pleft10 red ">Sold</span>
                                                           }
                                                       </span>
                                                   }
                                                   {_.get(row, ['CustomData', 'UserNotes']) &&
                                               <IODocumentText className="pull-left purple font-size-25 cursor-pointer" onClick={()=>{
                                                   this.props.openModalDialog(row, 'DisplayUserNotes' )
                                               }}
                                               ></IODocumentText>
                                               }

                                               </div>

                                           }}}
                                           dataSort={true}>Title</TableHeaderColumn>
                        <TableHeaderColumn width="150px" dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                           hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn width="60px" dataField='Markets.0.MarketName' dataAlign="center"    dataFormat={ customFormatter }
                            formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                 return  _.get(_.find(config.warehouseData, {MarketName: _.get(row, ['Markets', '0','MarketName'])}), 'provinceCode','')

                        }}}    dataSort={true}>Location</TableHeaderColumn>
                        <TableHeaderColumn width="60px" dataField='Condition' dataAlign="center"
                                           dataSort={true}>Condition</TableHeaderColumn>
                        <TableHeaderColumn width="60px"  formatExtraData={ {path:[  'Price']}  }    dataFormat={ priceFormatter } dataField='Price' dataAlign="center"dataSort={true}>Price</TableHeaderColumn>
                        <TableHeaderColumn width="70px" dataField='PublishedInShopifyAt'  dataAlign="center" dataFormat={ dateFormatter }
                                           formatExtraData={ {'name': 'PublishedInShopifyAt', 'format': 'MM/DD/YY'} }
                                           dataSort={true}>Date Listed</TableHeaderColumn>
                        <TableHeaderColumn width="70px" dataField='ProductSubscriptions'  dataAlign="center"
                                            dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                                return <div>
                                                       {_.map(_.get(row,'ProductSubscriptions',[]),(item,index)=> {
                                                           return <div key={index}>{_.startCase(_.get(item, 'Type')) }</div>
                                                       })}
                                               </div>
                                           }
                                           }}
                                           dataSort={true}>Subscriptions</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center"   dataField='Description'
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               return <div>
                                                   <FaCopy className="purple font-size-25 cursor-pointer" onClick={()=>{
                                                       this.props.openModalDialog(row, 'CopyDescription' )
                                                   }} ></FaCopy>
                                                       </div>
                                               }
                                           }}
                                           dataSort={true}>Description</TableHeaderColumn>
                        <TableHeaderColumn width="70px" dataField=''  dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               return <div>
                                                   {_.includes(_.get(row, 'ProductTags', []), 'Shipping Options_Shippable') ? 'Shippable' : ''}
                                               </div>
                                           }
                                           }}
                                            >Shipping</TableHeaderColumn>
                        <TableHeaderColumn width="70px" dataField='ProductSubscriptions'  dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               return <div>
                                                   <Checkbox onChange={(e) => {
                                                       var dataToUpdate = {
                                                           CustomData: {
                                                               CrossPosted:_.get(row, 'CustomData.CrossPosted') && _.get(row, 'CustomData.CrossPosted') !== 'unset'  ? 'unset':true,
                                                           }
                                                       }
                                                    this.props.updateProductRecord(row, dataToUpdate)

                                                   }}
                                                             checked={_.get(row, 'CustomData.CrossPosted') && _.get(row, 'CustomData.CrossPosted') !== 'unset' ?true:false} inline><span className="left5"></span></Checkbox>
                                               </div>
                                           }
                                           }}
                                           dataSort={true}>Cross-Posted</TableHeaderColumn>
                        <TableHeaderColumn width="65px"
                                            columnClassName={  'table-cell-with-image' }
                                           // dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           //     return imagesFormatter.call(this,  row,  rowIndex,{
                                           //     displayMultipleImages:true,
                                           //         imagePath:   ['OriginalImages'],
                                           //         total:this.props.total,
                                           //         perPage:this.state.perPage,
                                           //         currentPage:this.props.currentPage,
                                           //     } )
                                           // }}
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               if (_.get(row, 'OriginalImages.0')){
                                                   return <div onClick={()=>{
                                                       this.props.openModalDialog(row, 'DisplayProductImages' )
                                                   }} className='image-wrapper'>
                                                       <img title={''}  src={formatImageForBucket(_.get(row, 'OriginalImages.0.URL'))} />
                                                   </div>
                                               }

                                           }
                                           }}
                                           dataField="OriginalImages"
                                           dataAlign="center"
                                           dataSort={true}>
                            Images
                        </TableHeaderColumn>




                        <TableHeaderColumn width="30px" dataAlign="center"  columnClassName={'actions-column'}
                                           dataFormat={ this.customActionsFormatter.bind(this) }
                        >Actions</TableHeaderColumn>
                    </BootstrapTable>
                </div>

            </div>

        );
    }
}


export default AMTSalesProductsListTable;
